import { Box, Chip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { chipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const BranchChip = styled(Chip)(() => ({
  [`&.${chipClasses.root}`]: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",

    backgroundColor: colors.brandBlue50,
    borderRadius: "4px",
    color: colors.brandBlue600,
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    margin: "2px",
    height: "24px",
    maxWidth: "86px",
    width: "fit-content",
  },
}));

export const BranchBox = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  textOverflow: "ellipsis",
  height: 40,
  alignItems: "center",
}));

export const ModalContentWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  width: "100%",
}));

export const useStyles = makeStyles({
  modal: {
    width: "442px !important",
  },
  select: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    "& fieldset": {
      "& legend": {
        fontSize: 0,
        margin: 0,
        "& span": {
          display: "none",
        },
      },
    },
  },
  listSpan: {
    display: "flex",
    alignItems: "center",
    color: colors.brandBlue500,
  },
});
